import { FieldDescription, FieldError, FieldLabel, FieldLabelHint, FieldRoot, FieldValidation } from "../components/field.js";
import { InputBase } from "../components/input-base.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { z } from "zod";
import PhoneNumberInput from "react-phone-number-input/input";
import { formatE164, isValidPhone } from "@miter/utils";
//#region src/smart-components/phone-input.tsx
const DEFAULT_COUNTRY = "US";
const PHONE_PLACEHOLDER = "(555) 123-4567";
const normalizePhoneValue = (value) => {
	if (typeof value === "string") return value.trim();
	if (value == null) return "";
	return value;
};
const toE164 = (value) => formatE164(value) ?? value;
const possiblePhoneToE164 = (message) => z.string().refine(isValidPhone, message).transform(toE164);
const phoneNumberSchema = (message) => z.preprocess(normalizePhoneValue, z.string().refine((value) => value === "" || isValidPhone(value), message).transform((value) => value === "" ? "" : toE164(value)));
const requiredPhoneNumberSchema = (message) => z.preprocess(normalizePhoneValue, possiblePhoneToE164(message));
const phoneInputSchema = phoneNumberSchema("Enter a valid phone number");
const requiredPhoneInputSchema = requiredPhoneNumberSchema("Enter a valid phone number");
const PhoneInput = ({ autoComplete = "tel", className, description, disabled = false, errors, form, hint, id, label, name, onChange, placeholder = PHONE_PLACEHOLDER, required = false, value, warnings, wrapperClassName, ref, ...inputProps }) => {
	const submittedValue = value ?? "";
	return /* @__PURE__ */ jsxs(FieldRoot, {
		id,
		disabled,
		required,
		invalid: Boolean(errors),
		className: wrapperClassName,
		children: [
			label && /* @__PURE__ */ jsxs(FieldLabel, { children: [label, hint && /* @__PURE__ */ jsx(FieldLabelHint, { children: hint })] }),
			description && /* @__PURE__ */ jsx(FieldDescription, { children: description }),
			/* @__PURE__ */ jsx(PhoneNumberInput, {
				ref,
				...inputProps,
				autoComplete,
				className,
				defaultCountry: DEFAULT_COUNTRY,
				disabled,
				inputComponent: InputBase,
				placeholder,
				value: submittedValue || void 0,
				onChange: (nextValue) => {
					onChange?.(nextValue ?? "");
				}
			}),
			name && /* @__PURE__ */ jsx("input", {
				type: "hidden",
				name,
				value: submittedValue,
				disabled,
				form
			}),
			errors && /* @__PURE__ */ jsx(FieldError, { children: errors }),
			!errors && warnings && /* @__PURE__ */ jsx(FieldValidation, {
				variant: "warning",
				children: warnings
			})
		]
	});
};
//#endregion
export { PhoneInput, phoneInputSchema, phoneNumberSchema, requiredPhoneInputSchema, requiredPhoneNumberSchema };

//# sourceMappingURL=phone-input.js.map